var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLinkedinlogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 72 72",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m8 0c-4.4183 8.1162e-16 -8 3.5817-8 8v56c5.4108e-16 4.4183 3.5817 8 8 8h56c4.4183 0 8-3.5817 8-8v-56c0-4.4183-3.5817-8-8-8h-56zm8.3496 10c3.5073 0 6.3477 2.8638 6.3477 6.3965s-2.8404 6.3984-6.3477 6.3984c-3.5073 0-6.3496-2.8658-6.3496-6.3984s2.8423-6.3965 6.3496-6.3965zm33.033 16.273c7.3531 0 12.617 4.4906 12.617 13.777v21.949h-10.684v-18.197c0-4.9894-1.8966-7.7773-5.8457-7.7773-4.2961 0-6.541 2.9013-6.541 7.7773v18.197h-10.297v-34.666h10.297v4.668s3.0966-5.7285 10.453-5.7285zm-38.35 1.0605h10.736v34.666h-10.736v-34.666z",
    fill: "#252525"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedinlogo);
export default __webpack_public_path__ + "static/media/linkedinlogo.3f3988f038331a9f156759076cf312a3.svg";
export { ForwardRef as ReactComponent };